export const fieldSelector = <T = any>(path: string, field: keyof T) => {
  return (state: Record<string, any> = {}) => {
    if (!state[path]) return undefined;
    const targetState: T = state[path];
    return targetState[field] as T[typeof field];
  };
};
